import { Popover as MuiPopover, styled, Typography } from '@mui/material';

export const Popover = styled(MuiPopover)({
  '& .MuiPaper-root': {
    width: 320,
    maxHeight: 400,
    borderRadius: '12px',
    mt: 1,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    border: '1px solid #e2e8f0',
    overflow: 'hidden',
  },
});

export const Header = styled('div')({
  padding: '0.75rem 1rem',
  borderBottom: '1px solid #e2e8f0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: '#f8fafc',
});

export const Close = styled('button')({
  background: 'transparent',
  border: 'none',
  fontSize: 24,
  cursor: 'pointer',
  color: '#64748b',
  lineHeight: 1,
  padding: 0,
  transition: 'color 0.2s ease',
  '&:hover': { color: '#334155' },
});

export const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '100%',
});

export const List = styled('div')({
  overflowY: 'auto',
  maxHeight: 350,
  padding: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
});

export const Item = styled('button', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ isActive }) => ({
  width: '100%',
  background: isActive ? '#dbeafe' : '#f8fafc',
  border: `1px solid ${isActive ? '#0a80e0' : '#e2e8f0'}`,
  borderWidth: isActive ? 2 : 1,
  borderRadius: 8,
  padding: '0.75rem',
  marginBottom: '0.5rem',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.35rem',
  '&:hover': {
    background: '#eff6ff',
    borderColor: '#0a80e0',
    transform: 'translateX(3px)',
  },
  '& > div': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 12,
    gap: '8px',
  },
}));

export const ItemTitle = styled(Typography)({
  fontSize: '12px',
  fontWeight: 600,
  color: '#475569',
  flex: 1,
});

export const ItemDate = styled(Typography)({
  color: '#94a3b8',
  fontSize: 11,
  whiteSpace: 'nowrap',
});

export const RemoveButton = styled('button')({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: 18,
  padding: '4px',
  borderRadius: '4px',
  ':hover': {
    background: '#fee2e2',
  },
});

export const Message = styled('div')({
  fontSize: '13px',
  color: '#64748b',
  lineHeight: 1.4,
});

export const Count = styled('div')({
  fontSize: '11px',
  color: '#94a3b8',
  fontStyle: 'italic',
});
